import {Collapse, Modal, Tab, Tooltip} from 'bootstrap'

const queryIncludingRoot = <T extends HTMLElement>(root: ParentNode, selector: string): T[] => {
  const elements = Array.from(root.querySelectorAll<T>(selector))

  if (root instanceof HTMLElement && root.matches(selector)) {
    elements.unshift(root as T)
  }

  return elements
}

const initializeBootstrapElements = (root: ParentNode) => {
  queryIncludingRoot<HTMLElement>(root, '[data-bs-toggle="tab"]').forEach((element) => {
    Tab.getOrCreateInstance(element)
  })

  queryIncludingRoot<HTMLElement>(root, '[data-bs-toggle="tooltip"]').forEach((element) => {
    Tooltip.getOrCreateInstance(element, {
      boundary: document.body,
      container: document.body,
      trigger: element.dataset.bsTrigger ?? 'hover focus',
    })
  })

  queryIncludingRoot<HTMLElement>(root, '.modal').forEach((element) => {
    Modal.getOrCreateInstance(element)
  })

  queryIncludingRoot<HTMLElement>(root, '.collapse').forEach((element) => {
    Collapse.getOrCreateInstance(element, {toggle: false})
  })
}

const installBootstrapInterop = () => {
  initializeBootstrapElements(document)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          initializeBootstrapElements(node)
        }
      })
    })
  })

  observer.observe(document.body, {childList: true, subtree: true})
  return () => observer.disconnect()
}

export {installBootstrapInterop}
